'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var formatDate = exports.formatDate = function formatDate(value, locale) {
    var intlAvailable = typeof global.Intl !== 'undefined' && Intl.DateTimeFormat;

    if (!intlAvailable) {
        return value.split("T")[0];
    } else {
        return new Intl.DateTimeFormat(locale || 'en', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }).format(new Date(value));
    }
};
//# sourceMappingURL=dateUtils.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/util/dateUtils.js
 ** module id = 218
 ** module chunks = 0 1
 **/